
import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import {
  ShortMessagePostRequest,
  ShortMessagePostResponse,
} from '../entities/short-message-request-configuration-v1/models';
import { axiosInstance } from "../axios-instance";

class ShortMessageRequestConfiguration {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  queueShortMessageForAssetOrDevice(
    input: ShortMessagePostRequest,
    classificationType?: any,
  ): Promise<AxiosResponse<ShortMessagePostResponse>> {
    const accessToken = localStorage.getItem('accessToken');
    const queryParameters = { ...classificationType };
    return axiosInstance.post<ShortMessagePostResponse>(`${this.baseUrl}/queueConfigs`, input, {
      params: queryParameters,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }
}

export default ShortMessageRequestConfiguration;
